<mat-card appearance="outlined" class="lockcard">
  <mat-card-content>
    <mat-form-field>
      <input type="password" matInput placeholder="Unlock Passcode" autocomplete="off" #MachineName [(ngModel)]="lockPasscode" [disabled]="locked || (hubConn && hubConn.state == HubConnectionState.Connected)" />
    </mat-form-field>
    <mat-form-field>
      <input type="text" matInput placeholder="Machine Name" #MachineName [(ngModel)]="machineName" [disabled]="hubConn && hubConn.state == HubConnectionState.Connected" />
    </mat-form-field>
    <p>To unlock a terminal press <strong>CTRL + ALT + ~</strong> on the keyboard.</p>
  </mat-card-content>
  <mat-card-actions>
    @if (!hubConn || (hubConn && hubConn.state == HubConnectionState.Disconnected)) {
      <button mat-flat-button color="primary" (click)="connect()">Connect</button>
    }
    @if (hubConn && hubConn.state == HubConnectionState.Connected && overlayRef) {
      <button mat-flat-button color="primary" (click)="build()">Open</button>
    }
    @if (hubConn && hubConn.state == HubConnectionState.Connected) {
      <button mat-flat-button color="accent" (click)="disconnect()">Disconnect</button>
    }
  </mat-card-actions>
</mat-card>

<ng-template #overlayTemplate>
  <div style="width: 100%; background: #FFF">
    @if (iFrameUrl) {
      <iframe [src]="iFrameUrl" style="width: 100%; height: 100%; border: none;" frameborder="0"></iframe>
    }
  </div>
</ng-template>

<ng-template #unlockTemplate let-dialogRef="dialogRef">
  <mat-form-field>
    <input type="password" matInput placeholder="Passcode" #UnlockPasscode />
  </mat-form-field>
  <button mat-flat-button color="primary" (click)="tryUnlock(UnlockPasscode.value)">Unlock</button>
  <button mat-button (click)="dialogRef.close(false)">Cancel</button>
</ng-template>
